import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../Shared/Redux/store';

const initialState = {
  editAcademicData: null,
  academicMetadata: null,
  isAddAcademicModalOpen: false,
  isMakeActiveModalOpen: false,
  modalMode: '',
};

const academicSlice = createSlice({
  name: 'academic',
  initialState,
  reducers: {
    setEditacademicData: (state, action: PayloadAction<any>) => {
      state.editAcademicData = action.payload;
    },
    setAcademicYearMetadata: (state, action: PayloadAction<any>) => {
      state.academicMetadata = action.payload;
    },

    setIsAddacademicModalOpen: state => {
      state.isAddAcademicModalOpen = !state.isAddAcademicModalOpen;
    },
    setIsMakeActiveModalOpen: state => {
      state.isMakeActiveModalOpen = !state.isMakeActiveModalOpen;
    },
    setModalMode: (state, action: PayloadAction<any>) => {
      state.modalMode = action.payload;
    },
  },
});

export const selectIsAddacademicModalOpen = (state: RootState) =>
  state.academic.isAddAcademicModalOpen;

export const selectEditacademicData = (state: RootState) =>
  state.academic.editAcademicData;

export const selectIsMakeActiveModalOpen = (state: RootState) =>
  state.academic.isMakeActiveModalOpen;

export const selectModalMode = (state: RootState) => state.academic.modalMode;

export const selectAcademicMetadata = (state: RootState) =>
  state.academic.academicMetadata;

export const {
  setEditacademicData,
  setIsAddacademicModalOpen,
  setAcademicYearMetadata,
} = academicSlice.actions;
export default academicSlice.reducer;
